import { IconWithText } from '@components/icon-with-text'
import * as React from 'react'
import { PriceWithSpinner } from '@components/price-with-spinner'

interface Props {
  text: string
  price: string | number
  onDelete?: () => void
  isPriceCalculating?: boolean
  isDeleteEnabled?: boolean
}

export const ImprovementSummaryModalRow = ({
  text,
  price,
  onDelete,
  isPriceCalculating,
  isDeleteEnabled = true,
}: Props): JSX.Element => (
  <div className="border-top" role="improvement-summary-row">
    <div className="p-3 px-xl-4 d-flex justify-content-between align-items-center container-lg">
      <div>
        <IconWithText
          text={
            <>
              {text}
              {isDeleteEnabled && (
                <i
                  data-testid="improvement-row-delete"
                  className="uil-trash-alt text-muted ms-2 font-size-xl cursor-pointer d-inline-block"
                  onClick={onDelete}
                />
              )}
            </>
          }
          iconClassName="uil-check text-primary me-2 font-size-xl"
          className="d-inline-flex text-muted"
        />
      </div>
      <PriceWithSpinner
        pricePrefix="+"
        priceItemClassName="d-block text-darker-gray ms-2"
        isLoading={!!isPriceCalculating}
        price={price}
      />
    </div>
  </div>
)
